module.exports = __webpack_public_path__ + "static/media/cnx.73685f6c.png";